import React from "react"
import { injectIntl } from "react-intl"
import Icon from "../../../common/icon/icon.component"
import IntlProps from "../../../state/helpers/IntlProps"
import { CONTROL_PANEL_MESSAGES } from "../../../utils/inventory"
import { NewStockMovementModal } from "../../modals"

export const ControlPanel = injectIntl((props: IntlProps) => {
    const [showModal, setShowModal] = React.useState(false)

    const onClick = () => {
        setShowModal(true)
    }

    return (
        <>
            <button onClick={onClick} className="btn btn-primary">
                <>
                    <Icon value={"plus"} className={"pr-2"}></Icon>
                    {props.intl.formatMessage(CONTROL_PANEL_MESSAGES["btnText"])}
                </>
                
            </button>
            
            {showModal &&
                <NewStockMovementModal
                    onCloseCallback={() => setShowModal(false)}
                />
            }
        </>
    )
})


// WEBPACK FOOTER //
// ./src/inventory/sections/control/ControlPanel.tsx